import styles from "./TeacherProLib.module.css";
import OtherNAV from "../../jene/home/home-nav/ParentOtherNAV";
import TeacherProLibFilterPart from './TeacherProLibFilterPart'
import Footer from "../../Jimson/ProjectLibrary/ComponentsForProjectLibrary/Footer"
import OrangeButton from "../../../common/ui/OrangeButton";
import PinkButton from "../../../common/ui/PinkButton";
import { Link } from "react-router-dom";

//copied a structure of Jimson's ProjectLibraryPage.js

export default function TeacherProLib() {
  return (
    <div className={styles.containerProjectLibraryPage}>
      <OtherNAV />
      <div className={styles.projectText}>
        <h1>PROJECTS</h1> <br />
        <h4>
          Welcome to the project library. You can use the filters on the right to help you search for specific projects.
        </h4>
      </div>
      <div className={styles.projects}>
        <TeacherProLibFilterPart />
      </div>
      <div className={styles.bttButtonDiv}>
        <OrangeButton name="BACK TO TOP" />
        <Link to="/progress-tracker">
          <PinkButton name="BACK TO DASHBOARD" />
        </Link>
      </div>
      <Footer />
    </div>
  );
}
